module.exports = __webpack_public_path__ + "static/elephantcomfblanket1-ed77771a04be7e12c3a14b9eb5d93318.jpeg";